module.exports = __webpack_public_path__ + "static/media/flag_red.208b0d9a.svg";